import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ColumnExportButton, Table } from 'barnyard/components';
import { format_dollars } from '~/app/common/utils';


const BillMismatchTable = ({ orders, includeExport }) => {
  const columns = [{
    Header: 'Vetcove ID',
    accessor: 'id',
  }, {
    Header: 'Date',
    accessor: 'date',
  }, {
    Header: 'Order #',
    accessor: 'id',
  }, {
    Header: 'Billed To',
    accessor: 'billing_address',
  }, {
    Header: 'Total Price',
    id: 'total_price',
    accessor: row => format_dollars({ integer: row.total, include_cents: true }),
  }, {
    Header: 'Link',
    accessor: 'id',
    Cell: ({ value }) => <Link to={`/corporate/history/order/${value}`}>View Order</Link>,
    includeInExport: false
  }];

  return (
    <Table
      actions={includeExport && (
        <div className='u-paddingTop10'>
          <ColumnExportButton
            filename='Vetcove_Bill_Mismatch.csv'
            data={orders}
            columns={columns}
          >
            Download
          </ColumnExportButton>
        </div>
      )}
      size='small'
      columns={columns}
      data={orders}
      pageSize={orders.length || 10}
      showPagination={false}
    />
  );
};

BillMismatchTable.propTypes = {
  orders: PropTypes.array.isRequired,
  includeExport: PropTypes.bool
};

export default BillMismatchTable;
